import CitySEOHead from "@/components/feature/CitySEOHead";
import AlbuquerqueHeroSection from "./components/HeroSection";
import AlbuquerqueStickyNav from "./components/StickyNav";
import AlbuquerqueProcessingTimeSection from "./components/ProcessingTimeSection";
import AlbuquerqueServicesSection from "./components/ServicesSection";
import AlbuquerqueLocalAreaSection from "./components/LocalAreaSection";
import AlbuquerqueTestimonialsSection from "./components/TestimonialsSection";
import AlbuquerqueAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AlbuquerqueComparisonSection from "./components/ComparisonSection";
import AlbuquerqueMistakesSection from "./components/MistakesSection";
import AlbuquerqueHowItWorksSection from "./components/HowItWorksSection";
import AlbuquerqueFAQSection, { faqs } from "./components/FAQSection";
import AlbuquerqueHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AlbuquerqueFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import AlbuquerqueTravelTimingSection from "./components/TravelTimingSection";
import AlbuquerqueDestinationsSection from "./components/DestinationsSection";

const albuquerqueFaqs = faqs as { q: string; a: string }[];

const albuquerqueServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function AlbuquerquePage() {
  return (
    <>
      <CitySEOHead
        city="Albuquerque"
        state="New Mexico"
        stateAbbr="NM"
        route="/cities/albuquerque"
        title="Emergency Passport Albuquerque, NM — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Albuquerque, NM — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Kirtland AFB military families, Sandia Labs professionals, UNM students, and cross-border family travelers."
        geoPlacename="Albuquerque, New Mexico"
        geoPosition="35.0844;-106.6504"
        faqs={albuquerqueFaqs}
        servicesSchema={albuquerqueServices}
        statePageName="New Mexico"
        statePageRoute="/states/new-mexico"
      />
      <div className="font-sans">
        <AlbuquerqueHeroSection />
        <AlbuquerqueStickyNav />
        <AlbuquerqueProcessingTimeSection />
        <AlbuquerqueServicesSection />
        <AlbuquerqueLocalAreaSection />
        <AlbuquerqueTravelTimingSection />
        <AlbuquerqueDestinationsSection />
        <AlbuquerqueTestimonialsSection />
        <AlbuquerqueAcceptanceFacilitiesSection />
        <AlbuquerqueComparisonSection />
        <AlbuquerqueMistakesSection />
        <AlbuquerqueHowItWorksSection />
        <AlbuquerqueFAQSection />
        <AlbuquerqueHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/albuquerque" state="NM" />
        <AlbuquerqueFinalCTA />
      </div>
    </>
  );
}